import { Dispatch, SetStateAction } from 'react';
import clsx from 'clsx';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { Tab } from '@headlessui/react';
import { Minus, Plus } from 'lucide-react';
import { Typography } from '@/components/common';
import { CheckCircle } from '@/public/icons/tsx';
import { InputRadio } from '@/components/form';
import { PaymentType } from '@/interfaces';

type OptionType = {
	label: string;
	name: string;
	icon: JSX.Element;
	isAdded?: boolean;
	component: React.FC<any>;
};

interface Props {
	index: number;
	selectedIndex: number;
	setSelectedIndex: Dispatch<SetStateAction<number>>;
	register: UseFormRegister<FieldValues>;
	option: OptionType;
	paymentSelected: PaymentType | null;
	setPaymentSelected: (value: PaymentType) => void;
}

export const PaymentTab: React.FC<Props> = ({
	index,
	selectedIndex,
	option,
	setSelectedIndex,
	register,
	paymentSelected,
	setPaymentSelected,
}) => {
	return (
		<Tab
			className={clsx(
				'bg-white border rounded-3xl h-14 py-4 px-8 !outline-none w-full flex items-center',
				{
					'border-green-base': selectedIndex === index,
					'border-[#0D061633]': selectedIndex !== index,
				}
			)}
			onClick={() => {
				setSelectedIndex(index);
			}}
		>
			<div className="flex flex-1 justify-between items-center">
				<div className="flex flex-1 items-center">
					{option.isAdded && (
						<InputRadio
							name="payment"
							register={register}
							onChange={(e) => {
								const value = e.target.value as PaymentType;
								setPaymentSelected(value);
							}}
							value={option.name}
							// className="mr-2"
							// hidden={!option.isAdded}
							defaultChecked={option.name === paymentSelected}
						/>
					)}
					<div className="flex items-center gap-2">
						<div className="w-5">{option.icon}</div>
						<div className="flex items-center gap-4">
							<p
								className={clsx('text-base text-left line-clamp-1', {
									'font-semibold':
										selectedIndex === index || option.name === paymentSelected,
								})}
							>
								{option.label}
							</p>
							<div
								className={clsx('flex items-center gap-1', {
									hidden: !option.isAdded,
								})}
							>
								<Typography
									type="regular-12"
									className="text-green-130"
									text="Added"
								/>
								<CheckCircle className="text-green-130 !w-3 !h-3" />
							</div>
						</div>
					</div>
					{/* </InputRadio> */}
				</div>
				<div>
					{selectedIndex === index ? <Minus width={16} /> : <Plus width={16} />}
				</div>
			</div>
		</Tab>
	);
};
